import { createSelector } from 'reselect';
import { getActiveLocaleSelector } from '@americanexpress/travel-selectors';
import { getEwpDomainSelector, getAkamaiDomainSelector } from './getDomainSelectors';

export const getUrlSelectors = createSelector(
  getEwpDomainSelector,
  (ewpDomain) => `${ewpDomain}/travel/v2/kyt/insights/hotels/inquiry_results`
);

export const getInspiredExploreMoreUrlSelector = createSelector(
  getAkamaiDomainSelector,
  getActiveLocaleSelector,
  (akamaiDomain, locale) => `${akamaiDomain}/${locale.toLowerCase()}/travel/get-inspired`
);
